import _ from "lodash"
import packageConfig from "../package.json"

export class Volcengine {
  constructor(params) {
    this.commonAnalysisKey = "analyticCache"
    this.initParam = params
    this.resetDefaultParams()
    this.setSystemPlateformType(params.type)
    this.isInit = Boolean(this.getCacheTime())
    this.getVolcegineProps()
  }
  /**
   * 初始化火山引擎： 1、记录第一次进入App 访问时间 2、读取路由并写入缓存
   * @param {*} rouers
   * @param {*} tabBar
   */
  init(rouers, tabBar) {
    try {
      this.setCacheTime(new Date().getTime())
      this.updateRouter(rouers, tabBar)
      // 是否存在pages[0]
      if (this.pages[0]) {
        this.setCacheVisitUrl(this.pages[0])
      } else {
        if (!this.getCacheVisitUrl()) {
          const currentUrl = this.getNowPath(rouers)
          this.setCacheVisitUrl(currentUrl)
        }
      }
    } catch (e) {
      console.warn("火山引擎SDK 初始化错误: ")
      console.warn(e)
    }
  }

  /**
   * 读取路由信息并写入缓存
   * @param {*} rouers pages.json里面的 pages 参数
   * @param {*} tabBar pages.json里面的 tabBar.list 参数
   */
  updateRouter(rouers, tabBar) {
    let volcengineProps
    if (this.systemPlateformType) {
      volcengineProps = localStorage.getItem(this.cacheRoutersKey)
    } else {
      volcengineProps = uni.getStorageSync(this.cacheRoutersKey)
    }
    if (!volcengineProps) {
      volcengineProps = {}
    } else {
      volcengineProps = JSON.parse(volcengineProps)
    }
    try {
      const routeInfo = rouers
      const routeInfoRouter = this.forEachArr(routeInfo, 0)
      const tabbarInfo = tabBar
      const tabRouter = this.forEachArr(tabbarInfo, 1)
      this.volcengineProps = {
        ...routeInfoRouter,
        ...tabRouter
      }
      this.setVolcenginePropsCache()
    } catch (e) {
      console.warn("火山引擎SDK 更新路由信息 发生错误:")
      console.warn(e)
    }
  }

  /**
   * 获取公共属性
   * @param {*} path 当前的路由
   * @returns Object
   */
  getCommonAttr(path) {
    const commonAttr = this.commonAttr
    let emptyObject = {}
    commonAttr.forEach((item) => {
      emptyObject[item] = this.nullProp
      if (!this.volcengineProps[path]) {
        this.volcengineProps[path] = {}
      }
      const pathItem = this.volcengineProps[path]
      this.volcengineProps[path][item] = pathItem[item] || this.nullProp
    })
    if (!this.initParam.routerObject) {
      const sourceNameObject = this.getFromQueryNameContent(path)
      this.volcengineProps[path] = {
        ...this.volcengineProps[path],
        ...sourceNameObject
      }
    }
    return this.volcengineProps[path] || emptyObject
  }
  /**
   * 遍历数组
   * @param {Array} arr pages.json 对应的数组
   * @param {int} type 0-普通的路由 1-tabar
   */
  forEachArr(arr, type) {
    let volcengineProps = {}
    if (Array.isArray(arr)) {
      if (arr.length > 0) {
        arr.forEach((item) => {
          const path = type === 0 ? item.path : item.pagePath
          volcengineProps["/" + path] = {}
          volcengineProps["/" + path]["custom_page_url_path"] = "/" + path
          volcengineProps["/" + path]["custom_page_url"] = this.nullProp
          // 先默认为空，等对应的子类那边触发路由变化的时候再改
          const meta = item.meta || item.style
          const metaKeys = meta ? Object.keys(meta) : []
          if (metaKeys.length > 0) {
            metaKeys.forEach((keyName) => {
              if (this.commonAttrRealation[keyName]) {
                const volcengineKeyName = this.commonAttrRealation[keyName]
                volcengineProps["/" + path][volcengineKeyName] = meta[keyName]
              }
            })
          }
          const versionInfo = this.getVersionInfo()
          if (versionInfo) {
            volcengineProps["/" + path] = {
              ...volcengineProps["/" + path],
              ...versionInfo
            }
          }
          //存入meta 字段
          const itemMeta = item.meta
          const itemMetaKeys = itemMeta ? Object.keys(itemMeta) : []
          if (itemMetaKeys.length > 0) {
            itemMetaKeys.forEach((itemInfo) => {
              if (!["subAppName", "pageName"].includes(itemInfo)) {
                let volcengineFinalKey = itemInfo.replace(
                  /[A-Z]/g,
                  (key) => `_${key.toLowerCase()}`
                )
                volcengineProps["/" + path][volcengineFinalKey] =
                  itemMeta[itemInfo]
              }
            })
          }
        })
      }
    }
    return volcengineProps
  }

  /**
   * 初始化默认参数
   */
  resetDefaultParams() {
    this.nullProp = ""
    // 默认的空值
    this.commonAttr = [
      "custom_page_title",
      "custom_page_url_path", // /pages/xxx
      "custom_page_url", // https
      "sub_app_name",
      "custom_app_version_name" // 应用当前版本
    ]
    // 公共属性
    this.isVolcengine = true
    // 是否是火山引擎环境
    this.isError = false
    this.cacheTimeKey = "volcengineLastPageVisitTime"
    // 页面访问时间的缓存key
    this.cacheRoutersKey = "volcengineProps"
    // 路由信息的缓存key
    this.catcheVisitUrlKey = "volcengineLastUrl"
    // 版本信息的缓存key
    this.catcheVersionKey = "volcengineVersionInfo"
    // pc端vue-router 对应的 缓存（通过afterEach 才可以获得正确的数据）
    this.cacheRouterInfoKey = "volcengineRouterObjectInfo"
    this.commonAttrRealation = {
      pageName: "custom_page_title",
      path: "custom_page_url_path",
      subAppName: "sub_app_name",
      navigationBarTitleText: "custom_page_title"
    }
    // commonAttr 和 pages.json 里面对应关系
    // custom_page_url 不用写进去
    this.pages = []
    // 来源的key
    this.fromQueryNameCacheKey = "fromQueryNameCache"
    this.fromQueryNameArr = Array.isArray(this.initParam.eventQueryParams)
      ? this.initParam.eventQueryParams
      : []
  }

  /**
   * 设置当前项目所在用的平台
   * @param {number} type  0 uni-app 1 web
   */
  setSystemPlateformType(type) {
    this.systemPlateformType = type || 0 // 默认为uni-app
  }
  /**
   * 移除火山的全部缓存
   */
  removeCache() {
    if (this.systemPlateformType) {
      localStorage.removeItem(this.commonAnalysisKey)
    } else {
      uni.removeStorageSync(this.commonAnalysisKey)
    }
  }
  /**
   * 获取最后一次访问页面的时间
   */
  getCacheTime() {
    const path = this.commonAnalysisKey + "." + this.cacheTimeKey
    const cacheResult = this.getStorageByPath(path, 0)
    return cacheResult
  }
  /**
   * 设置页面访问的时间（写入缓存）
   * @param {*} time 页面访问时间
   */
  setCacheTime(time) {
    const path = this.commonAnalysisKey + "." + this.cacheTimeKey
    this.setStorageByPath(path, time)
  }
  /**
   * 获取上一次的路由访问地址
   * @returns
   */
  getCacheVisitUrl() {
    const path = this.commonAnalysisKey + "." + this.catcheVisitUrlKey
    const cacheResult = this.getStorageByPath(path, "")
    return cacheResult
  }
  /**
   * 设置上一次的路由访问地址
   * @returns
   */
  setCacheVisitUrl(url) {
    const path = this.commonAnalysisKey + "." + this.catcheVisitUrlKey
    this.setStorageByPath(path, url)
  }
  /**
   * 依据路由获取平台来源名称
   * 路由没有则从缓存中取
   * @param { String } path  路由
   * @returns 平台来源名称
   */
  getFromQueryNameContent(path) {
    const currentOptions = this.getCurrentOptions(path)
    let sourceNameObject = {}
    const cacheSourceNameObject = this.getFromQueryNameCache()
    let fromQueryNameArr = this.fromQueryNameArr
    let isNeedChangeCache = false
    if (fromQueryNameArr.length) {
      fromQueryNameArr.forEach((item) => {
        const itemResult = currentOptions[item] || cacheSourceNameObject[item]
        const changeCondition =
          currentOptions[item] &&
          cacheSourceNameObject[item] &&
          currentOptions[item] !== cacheSourceNameObject[item]
        const emptyChangeCondition =
          currentOptions[item] && !cacheSourceNameObject[item]
        // 当缓存和链接有不一致的时候更新缓存
        if (changeCondition || emptyChangeCondition) {
          isNeedChangeCache = true
        }
        sourceNameObject[item] = itemResult || this.nullProp
      })
      // 当有传入queryName 但无缓存的时候
      if (!Object.keys(cacheSourceNameObject).length || isNeedChangeCache) {
        this.setFromQueryNameCache(sourceNameObject)
      }
    } else {
      sourceNameObject = cacheSourceNameObject
    }
    return sourceNameObject
  }
  /**
   * 获取缓存的来源名称
   * @returns  { String }
   */
  getFromQueryNameCache() {
    const path = this.commonAnalysisKey + "." + this.fromQueryNameCacheKey
    const cacheResult = this.getStorageByPath(path, {})
    return cacheResult
  }
  /**
   * 设置缓存的来源名称
   */
  setFromQueryNameCache(source) {
    const path = this.commonAnalysisKey + "." + this.fromQueryNameCacheKey
    this.setStorageByPath(path, source)
  }
  /**
   * 获取用户行为分析的缓存
   */
  getVolcegineProps() {
    const path = this.commonAnalysisKey + "." + this.cacheRoutersKey
    let volcengineProps = this.getStorageByPath(path, null)
    if (!volcengineProps) {
      volcengineProps = {}
    } else {
      volcengineProps = JSON.parse(volcengineProps)
    }
    this.volcengineProps = volcengineProps
  }
  /**
   * 设置用户行为分析的缓存
   */
  setVolcenginePropsCache() {
    const volcenginePropsCache = JSON.stringify(this.volcengineProps)
    const path = this.commonAnalysisKey + "." + this.cacheRoutersKey
    this.setStorageByPath(path, volcenginePropsCache)
  }
  /**
   * 仅PC端生效 设置最新的路由信息
   *  @param {*} routerParam
   */

  setCurrentRouterInfo(routerParam) {
    const volcengineRouterInfoCache = JSON.stringify(routerParam)
    this.setStorageByPath(
      this.commonAnalysisKey + "." + this.cacheRouterInfoKey,
      volcengineRouterInfoCache
    )
  }
  getCurrentRouterInfo() {
    const path = this.commonAnalysisKey + "." + this.cacheRouterInfoKey
    let routerInfo = this.getStorageByPath(path, null)
    if (!routerInfo) {
      routerInfo = {}
    } else {
      routerInfo = JSON.parse(routerInfo)
    }
    return routerInfo
  }
  /**
   * 改变当前的页面栈
   * @param { Array } pages (由url 路径组成)
   */
  changeCurrentPage(pages) {
    this.pages = pages
  }
  /**
   * 获取页面栈
   * @param
   * @returns  Array(由url 路径组成)
   */
  getCurrentPagesArr() {
    const page = getCurrentPages()
      .map((e) => `/${e.route}`)
      .reverse() // 获取页面栈
    return page
  }
  getCurrentOptions(path) {
    let options = {}
    if (!this.initParam.uniPluginObject) {
      // uni-app
      try {
        const currentUrl = window.location.href
        options = this.getUrlParams(currentUrl)
      } catch (e) {}
    } else {
      const currentArr = getCurrentPages().filter((el) => {
        return "/" + el.route === path
      })
      const current = currentArr.length ? currentArr[0] : []
      options = current.options || {}
    }
    return options
  }
  /**
   * * @param {String} url
   *  获取url 后面的参数
   */
  getUrlParams(url) {
    let urlStr = url.split("?")[1]
    // 创建空对象存储参数
    let obj = {}
    // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split("&")
    for (let i = 0, len = paramsArr.length; i < len; i++) {
      // 再通过 = 将每一个参数分割为 key:value 的形式
      let arr = paramsArr[i].split("=")
      obj[arr[0]] = arr[1]
    }
    return obj
  }
  /**
   * 通过路径来获得存储数据
   * @param {*} path
   * @param {*} nullType
   * @returns
   */
  getStorageByPath(path, nullType = undefined) {
    path = typeof path === "string" ? path.split(".") : path
    path = path.filter((x) => x)
    // 1st 是 localStorage 的 key，2nd 开始才是对象 key path
    let lsValue
    if (this.systemPlateformType) {
      lsValue = localStorage.getItem(path[0]) || undefined
      if (lsValue) {
        try {
          lsValue = JSON.parse(lsValue)
        } catch (e) {
          lsValue = {}
        }
      }
    } else {
      lsValue = uni.getStorageSync(path[0]) || undefined
    }
    // 若 path 只有一级，直接读取
    const valueByPath =
      lsValue && path.length > 1 ? _.get(lsValue, path.slice(1)) : lsValue
    const result =
      !valueByPath && typeof nullType !== undefined ? nullType : valueByPath
    return result
  }

  /**
   * 通过路径来存储数据
   * @param {*} path
   * @param {*} nullType
   * @returns
   */
  setStorageByPath(path, value) {
    path = typeof path === "string" ? path.split(".") : path
    path = path.filter((x) => x)
    let result = ""
    if (path.length > 1) {
      // 若 path 不只一级，需要取出按 key 路径重新赋值
      let lsValue
      if (this.systemPlateformType) {
        lsValue = localStorage.getItem(path[0])
        if (lsValue) {
          try {
            lsValue = JSON.parse(lsValue)
          } catch (e) {
            lsValue = {}
          }
        } else {
          lsValue = {}
        }
      } else {
        lsValue = uni.getStorageSync(path[0]) || {}
      }

      result = _.set(lsValue, path.slice(1), value)
    } else if (path.length === 1) {
      // 若 path 只有一级，直接存入
      result = value
    }
    if (this.systemPlateformType) {
      localStorage.setItem(path[0], JSON.stringify(result))
    } else {
      uni.setStorageSync(path[0], result)
    }
    return !!result
  }
  getNowPath(routeInfo) {
    let currentUrl
    try {
      const routerArr = routeInfo
      if (this.systemPlateformType === 1) {
        const nowFullPath = window.location.href
        routerArr.forEach((item) => {
          if (nowFullPath.indexOf(item.path) > -1) {
            currentUrl = "/" + item.path
          }
        })
      }
      // 如果没有任何匹配的，那就是首页
      if (!currentUrl) {
        currentUrl = "/" + routeInfo[0].path
      }
    } catch (e) {
      currentUrl = "/"
    }
    return currentUrl
  }
  // 获得版本信息
  getVersionInfo() {
    try {
      let versionInfo = {
        analytics_sdk_version_name: packageConfig.version
      }
      const initParam = this.initParam

      // uni-app
      if (initParam.uniPluginObject) {
        const appWgtVersion = uni.getSystemInfoSync().appWgtVersion
        versionInfo.custom_app_version_name = appWgtVersion
      } else if (initParam.routerObject) {
        // web
        const packageVersion = WEB_VERSION.version || ""

        versionInfo.custom_app_version_name = packageVersion
      } else {
        // H5

        const version =
          uni.getSystemInfoSync().appWgtVersion ||
          uni.getSystemInfoSync().appVersion
        // 是否可以执行uni 对应的方法 > mainfestVersion > packageVersion
        versionInfo.custom_app_version_name = version
        if (!version) {
          versionInfo.custom_app_version_name =
            UNI_VERSION.versionName || UNI_VERSION.version
        }
      }
      return versionInfo
    } catch (e) {
      return {
        analytics_sdk_version_name: packageConfig.version,
        custom_app_version_name: ""
      }
    }
  }
}
